export const handleApiError = (err: unknown, defaultMessage: string): string => {
  console.error(`Error: ${defaultMessage}:`, err);
  return err instanceof Error ? err.message : defaultMessage;
}; 